<template>
    <student-backend-layout
        page-title="Interactive Exercises"
        header-bg-color="white"
        content-bg-color="gray-125"
    >
        <template #page_header>
            <div
                class="my-4 flex flex-col items-start justify-between gap-2 lg:flex-row lg:items-center"
            >
                <div class="flex flex-col gap-1">
                    <h1 class="text-[26px] font-bold">Interactive Exercises</h1>
                    <div class="text-[16px] text-gray-700">
                        A fun and engaging way to study your NREMT topics
                    </div>
                </div>
            </div>
        </template>

        <template #content>
            <div class="mt-4 px-4 lg:mt-8 lg:px-10">
                <div class="flex w-full flex-col gap-8 lg:flex-row">
                    <div class="hidden w-[280px] flex-none lg:block">
                        <student-worksheet-filters
                            :worksheet-filters-form="worksheetFiltersForm"
                        />
                    </div>

                    <div
                        class="flex h-auto w-full flex-col gap-2 bg-white pt-4 lg:shadow"
                    >
                        <div class="mx-4 text-[18px] font-bold">
                            {{ paginatedWorksheets.total }} Results
                        </div>
                        <div class="mx-4 flex gap-4 lg:hidden">
                            <div class="w-full">
                                <form-input
                                    type="search"
                                    placeholder="Search by title"
                                    v-model="worksheetFiltersForm.searchText"
                                />
                            </div>
                            <div class="">
                                <slide-over-menu open-from="right">
                                    <template #trigger>
                                        <span
                                            class="inline-block h-auto rounded border border-gray-400 px-3 py-2 text-gray-600 hover:cursor-pointer hover:bg-gray-300"
                                            >Filter</span
                                        ></template
                                    >
                                    <template #menu_content>
                                        <div
                                            class="flex h-full flex-col overflow-y-auto bg-white"
                                        >
                                            <div
                                                class="flex flex-col gap-2 px-4 py-4"
                                            >
                                                <student-worksheet-filters
                                                    :worksheet-filters-form="
                                                        worksheetFiltersForm
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </slide-over-menu>
                            </div>
                        </div>

                        <div class="mx-4 hidden lg:block">
                            <form-input
                                type="search"
                                placeholder="Search for interactive exercises by title"
                                v-model="worksheetFiltersForm.searchText"
                            ></form-input>
                        </div>

                        <StudentSelectedCategoriesList
                            :selected-categories="selectedCategories"
                            v-on:remove-category="removeCategory"
                        />
                        <div
                            v-if="!worksheets.length"
                            class="mx-4 flex flex-col gap-4 bg-gray-300 px-12 py-4 text-center"
                        >
                            <div class="font-semibold">
                                0 interactive exercises available
                            </div>
                            <div class="text-[16px] text-gray-700">
                                No interactive exercises available. Please
                                double check your filters and search query and
                                try again
                            </div>
                            <div
                                class="text-primary-525 hover:cursor-pointer hover:text-primary-600"
                                @click="clearFilters"
                            >
                                Clear Filters
                            </div>
                        </div>
                        <div class="flex flex-col">
                            <template v-for="worksheet in worksheets">
                                <student-worksheet-row :worksheet="worksheet" />
                            </template>
                        </div>
                        <ContentPaginator
                            :current-page="paginatedWorksheets.current_page"
                            :total-pages="paginatedWorksheets.last_page"
                            v-on:go-to-page="goToPage"
                        />
                    </div>
                </div>
            </div>
        </template>
    </student-backend-layout>
</template>

<script>
import StudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import SlideOverMenu from "@/Components/SlideOverMenu.vue";
import FormInput from "@/Components/FormSearch.vue";
import StudentWorksheetFilters from "@/Components/StudentWorksheetFilters.vue";
import StudentSelectedCategoriesList from "@/Components/StudentSelectedCategoriesList.vue";
import ContentPaginator from "@/Components/ContentPaginator.vue";
import StudentWorksheetRow from "@/Components/StudentWorksheetRow.vue";

export default {
    name: "StudentWorksheetsIndex",
    components: {
        StudentWorksheetRow,
        ContentPaginator,
        StudentSelectedCategoriesList,
        StudentWorksheetFilters,
        FormInput,
        SlideOverMenu,
        StudentBackendLayout,
    },
    props: {
        selectedCategories: {
            type: Array,
            default: [],
        },
        paginatedWorksheets: {
            type: Object,
            default: {},
        },
        worksheetFilters: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            worksheets: this.paginatedWorksheets.data,
            page: 1,
            worksheetFiltersForm: this.$inertia.form({
                progress: this.worksheetFilters.progress,
                categories: this.worksheetFilters.categories,
                searchText: this.worksheetFilters.searchText,
            }),
            maxVisibleSelectedCategories: 5,
        };
    },
    methods: {
        clearFilters() {
            this.$inertia.get(route("student.worksheets.index"));
        },
        removeCategory(categoryId) {
            let categoryIndex =
                this.worksheetFiltersForm.categories.indexOf(categoryId);
            this.worksheetFiltersForm.categories.splice(categoryIndex, 1);
        },
        goToPage(targetPage) {
            this.page = targetPage;
            this.updateFilteredWorksheets();
        },
        updateFilteredWorksheets() {
            let vm = this;

            vm.$inertia.get(
                route("student.worksheets.index"),
                {
                    filters: {
                        progress: vm.worksheetFiltersForm.progress,
                        categories: vm.worksheetFiltersForm.categories,
                        searchText: vm.worksheetFiltersForm.searchText,
                    },
                    page: this.page,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess() {
                        vm.worksheets = vm.paginatedWorksheets.data;
                    },
                }
            );
        },
    },
    mounted() {},
    watch: {
        worksheetFiltersForm: {
            handler() {
                this.page = 1;
                this.updateFilteredWorksheets();
            },
            deep: true,
        },
    },
};
</script>
